/**
 * English render vocabulary.
 *
 * Self-registering: importing this module makes the words available to
 * `render(node, 'en')`. Kept separate from the profile so a parse-only
 * bundle can drop it — see lexicon-registry.ts for why that separation exists.
 */
import type { LanguageLexicon } from '../generators/profiles/types';
import { registerLexicon } from '../lexicon-registry';

export const englishLexicon: LanguageLexicon = {
  events: {
    blur: { primary: 'blur' },
    change: { primary: 'change' },
    click: { primary: 'click' },
    dblclick: { primary: 'dblclick' },
    focus: { primary: 'focus' },
    input: { primary: 'input' },
    keydown: { primary: 'keydown' },
    keypress: { primary: 'keypress' },
    keyup: { primary: 'keyup' },
    load: { primary: 'load' },
    mousedown: { primary: 'mousedown' },
    mouseenter: { primary: 'mouseenter' },
    mouseleave: { primary: 'mouseleave' },
    mousemove: { primary: 'mousemove' },
    mouseout: { primary: 'mouseout' },
    mouseover: { primary: 'mouseover' },
    mouseup: { primary: 'mouseup' },
    reset: { primary: 'reset' },
    resize: { primary: 'resize' },
    scroll: { primary: 'scroll' },
    submit: { primary: 'submit' },
    touchcancel: { primary: 'touchcancel' },
    touchend: { primary: 'touchend' },
    touchmove: { primary: 'touchmove' },
    touchstart: { primary: 'touchstart' },
    unload: { primary: 'unload' },
  },
  logical: {
    and: { primary: 'and' },
    changes: { primary: 'changes' },
    contains: { primary: 'contains' },
    else: { primary: 'else' },
    end: { primary: 'end' },
    equals: { primary: 'equals' },
    exists: { primary: 'exists' },
    has: { primary: 'has' },
    have: { primary: 'have' },
    includes: { primary: 'includes' },
    is: { primary: 'is' },
    live: { primary: 'live' },
    matches: { primary: 'matches' },
    not: { primary: 'not' },
    or: { primary: 'or' },
    otherwise: { primary: 'otherwise' },
    then: { primary: 'then' },
    when: { primary: 'when' },
    where: { primary: 'where' },
  },
  temporal: {
    h: { primary: 'h' },
    hour: { primary: 'hour' },
    hours: { primary: 'hours' },
    millisecond: { primary: 'millisecond' },
    milliseconds: { primary: 'milliseconds' },
    min: { primary: 'min' },
    minute: { primary: 'minute' },
    minutes: { primary: 'minutes' },
    ms: { primary: 'ms' },
    s: { primary: 's' },
    second: { primary: 'second' },
    seconds: { primary: 'seconds' },
  },
  values: {
    body: { primary: 'body' },
    detail: { primary: 'detail' },
    document: { primary: 'document' },
    element: { primary: 'element' },
    event: { primary: 'event' },
    false: { primary: 'false' },
    it: { primary: 'it' },
    its: { primary: 'its' },
    me: { primary: 'me' },
    my: { primary: 'my' },
    myself: { primary: 'myself' },
    null: { primary: 'null' },
    result: { primary: 'result' },
    target: { primary: 'target' },
    true: { primary: 'true' },
    undefined: { primary: 'undefined' },
    value: { primary: 'value' },
    window: { primary: 'window' },
    you: { primary: 'you' },
    your: { primary: 'your' },
    yourself: { primary: 'yourself' },
  },
  attributes: {
    attribute: { primary: 'attribute' },
    attributes: { primary: 'attributes' },
    class: { primary: 'class' },
    classes: { primary: 'classes' },
    properties: { primary: 'properties' },
    property: { primary: 'property' },
    style: { primary: 'style' },
    styles: { primary: 'styles' },
  },
  expressions: {
    at: { primary: 'at' },
    children: { primary: 'children' },
    closest: { primary: 'closest' },
    empty: { primary: 'empty' },
    'ends with': { primary: 'ends with' },
    first: { primary: 'first' },
    'ignoring case': { primary: 'ignoring case' },
    'joined by': { primary: 'joined by' },
    last: { primary: 'last' },
    'mapped to': { primary: 'mapped to' },
    next: { primary: 'next' },
    no: { primary: 'no' },
    parent: { primary: 'parent' },
    prev: { primary: 'prev' },
    previous: { primary: 'previous' },
    random: { primary: 'random' },
    some: { primary: 'some' },
    'sorted by': { primary: 'sorted by' },
    'split by': { primary: 'split by' },
    'starts with': { primary: 'starts with' },
    within: { primary: 'within' },
  },
};

registerLexicon('en', englishLexicon);
